import React, { useEffect, useState } from "react";
import Closeicon from "../../images/Closeicon";
import {ChatState} from "../../Context/ChatProvider";

const idbManager = {
    dbName: "PWA_Data",
    storeName: "settings",
    
    async getDB() {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.dbName, 1);
            request.onupgradeneeded = () => request.result.createObjectStore(this.storeName);
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
        });
    },

    async setInstalled() {
        const db = await this.getDB();
        const tx = db.transaction(this.storeName, "readwrite");
        tx.objectStore(this.storeName).put(true, "isInstalled");
        return tx.complete;
    },

    async checkInstalled() {
        const db = await this.getDB();
        return new Promise((resolve) => {
            const tx = db.transaction(this.storeName, "readonly");
            const request = tx.objectStore(this.storeName).get("isInstalled");
            request.onsuccess = () => resolve(request.result || false);
        });
    }
};

const  InstallPWAPrompt= () => {
    const { setInstallApp} = ChatState();
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const { showToast } = ChatState();
    const [pwaStatus, setPwaStatus] = useState('checking'); // 'checking', 'canInstall', 'installed', 'notAvailable
 
   useEffect(() => {
            const handlePrompt = (e) => {
                e.preventDefault();
                setDeferredPrompt(e);
                setPwaStatus('ready_to_install');
            };
            window.addEventListener('beforeinstallprompt', handlePrompt);
            if (window.pwa_event) {
                handlePrompt(window.pwa_event);
            }
            const checkPwaStatus = async () => {
                try {
                    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
                    let wasInstalled = false;
                    if (idbManager && typeof idbManager.checkInstalled === 'function') {
                        wasInstalled = await idbManager.checkInstalled();
                    }
                    if (isStandalone || wasInstalled) {
                        setPwaStatus('installed');
                    }
                } catch (error) {
                    console.error("PWA status error:", error);
                }
            };
            checkPwaStatus();  
            return () => window.removeEventListener('beforeinstallprompt', handlePrompt);
        }, []);

    const handleInstallClick = async () => {
        if (pwaStatus === 'installed') {
            showToast("info", "Your app is already installed! Look for it among the apps on your device");
            return;
        }

        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === 'accepted') {
                if (idbManager) {
                    await idbManager.setInstalled();
                }
                if (navigator.storage && navigator.storage.persist) {
                    const isPersisted = await navigator.storage.persist();
                }
                setPwaStatus('installed');
                showToast("info", "The application installation process is in progress.");
            } 
            setDeferredPrompt(null);
        } else {
            const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
            console.log("isFirefox = ", isFirefox);
            if (isFirefox) {
                showToast("warning", "Firefox does not support direct installation of PWA on desktop. 🦊\n\nYou can add the site to 'Bookmarks' or use Chrome/Edge to run in standalone mode.");
            } else {
                showToast("warning", "Unfortunately, your browser is not ready to install this App at this time.");
            }
        };
    };

    return (
        <div className=' timeProfile' >
            {pwaStatus === 'installed' && (
                <div className="alert-info">🚀 You already use our App!</div>
            )}
            {  <div className = 'modalContent' >
                    <section className='modal_section'>
                        <div className = 'modal_header'>
                            <h2><span>Add </span><img src="./../../images/logo48.png"  alt="Bell" /> <span>to your home screen</span> </h2>
                        </div>
                        <button className='css-1ik4h6n buttonClose' type='button' aria-label='Close' onClick={()=>setInstallApp(false)} ><Closeicon /></button>
                        <div className='modal_body'>
                        <div><p className="install_h4">⚡️ 1. Instant Access and Speed</p>
                            The App is lightweight and optimized. Installation is instant — just add the icon to your screen. It only takes a few seconds.
                            <p className="install_h4">💰 2. Saving Space and Traffic</p>
                            The Sich App takes up ten times less space than regular native applications.
                            <p className="install_h4">🌐 3. Access Even Without a Network</p>
                            Thanks to PWA technology, you can work with messages even when your connection is lost.
                            <p className="install_h4">👉 4. Do it now!</p>
                            Install Sich App and get quick, easy and reliable access to all our features!</div>
                        </div>
                        <div className=" buttons_yes_no">
                            <button className="button" onClick={()=>handleInstallClick()} >Install</button>
                            <button className="button" onClick={()=>setInstallApp(false)} >Cancel</button>
                        </div>
                    </section>
                </div>}
        </div> 
    )
}
export default InstallPWAPrompt
